// components/piano/DynamicPiano.tsx

import React, {
  useState,
  useImperativeHandle,
  forwardRef,
  ForwardRefRenderFunction,
  useEffect,
} from "react";
import { Box } from "@chakra-ui/react";
import SubmitPiano from "components/piano/SubmitPiano";
import { ExerciseDefinition } from "utils/exercises/types";
import MidiNumbers from "components/piano/MidiNumbers";

export interface DynamicPianoHandle {
  getUserSelectedNotes: () => number[];
}

export interface DynamicPianoProps {
  exerciseDefinition: ExerciseDefinition;
  disabled?: boolean; // Optional disabled prop
  correctNotes?: number[]; // New prop for correct notes
}

const DynamicPiano: ForwardRefRenderFunction<
  DynamicPianoHandle,
  DynamicPianoProps
> = ({ exerciseDefinition, disabled, correctNotes = [] }, ref) => {
  const [userSelectedNotes, setUserSelectedNotes] = useState<number[]>([]);

  useEffect(() => {
    if (exerciseDefinition) {
      setUserSelectedNotes([]);
    }
  }, [exerciseDefinition]);

  useImperativeHandle(ref, () => ({
    getUserSelectedNotes: () => userSelectedNotes,
  }));

  // Define piano range
  const firstNote = MidiNumbers.fromNote("c3");
  const lastNote = MidiNumbers.fromNote("b5");

  const handlePlayNote = (midiNumber: number) => {
    if (!disabled) {
      // Check if interaction is not disabled

      setUserSelectedNotes((prev) => {
        // Toggle the note selection
        return prev.includes(midiNumber)
          ? prev.filter((n) => n !== midiNumber)
          : [...prev, midiNumber];
      });
    }
  };

  useEffect(() => {}, []);

  return (
    <Box
      textAlign="center"
      width="100%"
      opacity={disabled ? 0.4 : 1}
      pointerEvents={disabled ? "none" : "auto"}
      cursor={disabled ? "not-allowed" : "auto"}
    >
      <SubmitPiano
        noteRange={{ first: firstNote, last: lastNote }}
        keyColors={{}}
        keyBorderColors={{}}
        activeNotes={userSelectedNotes}
        correctNotes={disabled ? correctNotes : []}
        isSubmitted={disabled}
        playNote={handlePlayNote}
        stopNote={() => {}}
        width="100%"
        height="150px"
        disabled={disabled}
      />
    </Box>
  );
};

export default forwardRef<DynamicPianoHandle, DynamicPianoProps>(DynamicPiano);
